namespace GeniuzPOS.Purchase {
    export interface PoPurOrderPrintData extends Serenity.ListRequest {
        Header?: PoPurOrderRow;
        Supdata?: Supplier.CsSupplierRow;
        Details?: PoPurOrderDtRow[];
        SysDocNo?: string;
        URLpic?: string;
        Paydesc?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
        AppName?: string;
        AppDate?: string;
    }
}
